<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
          <back-arrow title="Modifier un état de santé"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b-form @submit.stop.prevent="onSubmit">

          <b-form-group
            id="name-input"
            label="Nom *"
            label-for="name-input"
            class="bold-label"
            :invalid-feedback="form.name.invalidFeedback"
            :state="form.name.state"
          >
            <b-form-input
              id="name-input"
              v-model="form.name.value"
              type="text"
              maxlength="250"
              :state="form.name.state"
              required
            ></b-form-input>
          </b-form-group>

          <div class="bold-text mt-4">Image *</div>

          <b-form-group class="mt-2">
            <b-form-radio-group
              v-model="form.imageName.value"
              button-variant="outline-primary"
              name="radio-btn-outline"
              buttons
            >
              <b-form-radio
                :value="imageName"
                v-for="imageName in imageNames"
                :key="imageName"
                class="state-radio"
              >
                <img class="w-100" :src="healthStatesImagesBaseUrl+imageName" alt="Image associée à l'état" :title="imageName">
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="secondary" :disabled="sendButtonDisabled">Valider</b-button>
          </div>
        </b-form>

      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";

export default {

  name: 'HealthStateEdit',

  components: {
    BackArrow
  },

  data() {
    return {
      sendButtonDisabled: false,
      healthStateId: this.$route.params.healthStateId,
      healthState: null,

      imageNames: [],

      form: {
        name: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        imageName: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  computed: {

    healthStatesImagesBaseUrl() {
      return process.env.SERVER_URL + '/assets/healthStates/'
    },

    isSmallScreen() {
      return window.innerWidth < 900
    }
  },

  methods: {

    fetchData() {
      this.fetchImagesFromEnum()
    },

    fetchImagesFromEnum() {
      api
        .get(`/healthState/getImagesFromEnum`)
        .then(response => {
          this.imageNames = response.data
          this.fetchHealthState()
        })
    },

    fetchHealthState() {
      api
        .get(`/healthState/${this.healthStateId}`)
        .then(response => {
          this.healthState = response.data
          this.setInitialValues()
        })
    },

    setInitialValues() {
      this.form.name.value = this.healthState.name
      this.form.imageName.value = this.healthState.imageName
    },

    onSubmit() {
      this.sendButtonDisabled = true

      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('imageName',  this.form.imageName.value)

      api({
        method: 'POST',
        url: `/healthState/${this.healthState.id}`,
        data: data
      })
        .then((response) => {
          this.$router.push({
            name: 'HealthStateIndex'
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })
        })
        .catch((error) => {
          this.sendButtonDisabled = false
          if (error.response.status === 418) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]["state"] = false
            this.form[invalidField]["invalidFeedback"] = error.response.data.message
          }
        });
    },

    successToast(healthStateName) {
      this.$bvToast.toast(`État de santé \"${healthStateName}\" modifié`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

.state-radio {
  width: 110px;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: var(--main-color-active);
  background-color: transparent;
  border-color: var(--main-color-active);
  box-shadow: 0 0 0 0.2rem var(--main-color-focus-shadow);
}

</style>



// WEBPACK FOOTER //
// src/views/healthState/HealthStateEdit.vue